import React, { useState } from 'react';

import { makeStyles } from '@material-ui/styles';
import { Button, CircularProgress } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  submitBox: {
    display: 'flex',
    alignItems: 'center',
  },
  wrapper: {
    margin: '24px 16px 24px 0',
    position: 'relative',
  },
  buttonProgress: {
    color: '#000',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

export const SaveChanges = ({ route, click, id, setShow }) => {
  const classes = useStyles();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);

  return (
    <div className={classes.submitBox}>
      <div className={classes.wrapper}>
        <Button
          onClick={() => click(setIsLoading, setShow)}
          color='primary'
          variant='contained'
          className={classes.saveButton}
          size='small'
          disabled={isLoading}
          id={`save-${id}`}
        >
          Save
        </Button>
        {isLoading && (
          <CircularProgress size={24} className={classes.buttonProgress} />
        )}
      </div>
      <Button
        size='small'
        variant='outlined'
        disabled={isLoading}
        onClick={() => history.push(route)}
      >
        Discard Changes
      </Button>
    </div>
  );
};
